import { includeGoodfillCommissionWithBasePrice } from "@goodfill/domain-math";
import { PricedBond } from "../../../bonds/PricedBond";
import { PresentedTradeTicket } from "./PresentedTradeTicket";
import { TIMEZONE_NEY_YORK } from "../../../../locale/timezone";
import { Currency } from "@goodfill/domain-properties";
import { PortfolioTradeTicket } from "../../../backendApi/amplifyGraphQl/PortfolioCustomTradeTicketList/PortfolioTradeTicket";

export const mapPortfolioTradeTicketToPresentedTradeTicket = (
  tradeTicket: PortfolioTradeTicket,
  pricedBond: PricedBond,
): PresentedTradeTicket => {
  const loadedTradePrice = includeGoodfillCommissionWithBasePrice(
    tradeTicket.bondPrice,
    { amount: tradeTicket.amount, currency: Currency.USD },
    tradeTicket.orderTicket.direction,
  );

  return {
    tradeTicketId: tradeTicket.id,
    tradeDate: tradeTicket.tradeDate,
    settlementDate: tradeTicket.settlementDate,
    bondId: pricedBond.bondIdCusip,
    bondTimezone: TIMEZONE_NEY_YORK,
    direction: tradeTicket.orderTicket.direction,
    ticker: pricedBond.issuerTicker,
    issuerId: pricedBond.issuerId,
    issuerName: pricedBond.issuerName,
    paymentRank: pricedBond.paymentRank,
    orderTicketId: tradeTicket.orderTicketId,
    isin: pricedBond.isin,
    couponPayment: pricedBond.couponPayment,
    maturityDate: pricedBond.maturityDate,
    amount: tradeTicket.amount,
    loadedTradePrice,
    tradeValue: tradeTicket.tradeValue,
    accruedInterest: tradeTicket.accruedInterest,
    settlementValue: tradeTicket.settlementValue,
    finalCommissionAmount: tradeTicket.finalCommissionAmount,
    bondRatingMoodys: pricedBond.ratings.moodys,
    bondRatingSp: pricedBond.ratings.sp,
  };
};
